"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.radii = void 0;
exports.radii = {
    radius0: 0,
    radius25: 2,
    radius50: 4,
    radius100: 8,
    radius200: 16
};
